import ReportPage from "../../components/ReportPage";
import { downloadTotalDistributionByBanner } from "../../API";

const schema = {
  title: "Total Distribution by Banner",
  params: [
    { name: "banners", label: "Banners", type: "multiselect", route: "banners", fields: ["name"], payloadKey: "bannerIds" },
    { name: "products", label: "Products", type: "multiselect", route: "products", cascadesFrom: "manufacturer", fields: ["description", "formatQut", "format"], payloadKey: "productIds" },
  ],
  downloadFn: downloadTotalDistributionByBanner,
};

export default function TotalDistributionByBannerReport() {
  return <ReportPage schema={schema} />;
}
